import { useCallback, useEffect, useState } from 'react'
import { CarePartnerResponseDTO, CarePartnersService } from '../client'

export const useCarePartnerByCandidate = (candidateId?: string) => {
    const [carePartner, setCarePartner] = useState<CarePartnerResponseDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const fetchCarePartner = useCallback(async () => {
        if (!candidateId) {
            setCarePartner(null)
            return
        }

        setLoading(true)
        setError(null)

        try {
            // First try the direct endpoint
            const response = await CarePartnersService.getCarePartnerByCandidateCarePartnersByCandidateCandidateIdGet({
                candidateId
            })
            setCarePartner(response)
        } catch (err) {
            // If direct endpoint fails, try listing all care partners and see if we can find one
            try {
                const allCarePartners = await CarePartnersService.listCarePartnersCarePartnersGet({
                    page: 1,
                    limit: 100, // Get more to increase chances of finding the right one
                    sort: 'created_dttm:desc'
                })

                // For now, just set to null since we can't determine the association
                if (allCarePartners.data && allCarePartners.data.length > 0) {
                    // TODO: We need to figure out how to identify which care partner belongs to this candidate
                    // This might require a different API endpoint or approach
                }

                setCarePartner(null) // For now, set to null since we can't determine the association
            } catch (fallbackErr) {
                setError('Failed to fetch care partner information')
            }
        } finally {
            setLoading(false)
        }
    }, [candidateId])

    useEffect(() => {
        fetchCarePartner()
    }, [fetchCarePartner])

    return { carePartner, loading, error, refetch: fetchCarePartner }
}
